import { render } from "./LoginAdm.vue?vue&type=template&id=06cd2c18&scoped=true"
import script from "./LoginAdm.vue?vue&type=script&lang=js"
export * from "./LoginAdm.vue?vue&type=script&lang=js"

import "./LoginAdm.vue?vue&type=style&index=0&id=06cd2c18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cd2c18"]])

export default __exports__